import React, { useState, useEffect } from 'react';
import { TextView } from "../TextView/TextView"
import { FaEyeSlash, FaEdit, FaEye, FaStar, FaToggleOn, FaRegImage, FaToggleOff } from 'react-icons/fa';
import { goToGitHubEdit } from '../utils';
import { Surface3Wrapper } from "../Surface3Wrapper";

// Add a reference to the declaration file for Surface3Wrapper module

// import { Surface3Wrapper } from '../src/components/Surface3Wrapper'




// Define props using an interface
export interface MyComponentProps {
  // Define your prop types here
  isMainText?: boolean,
  relationLabel?: string,
  targetRange?: string,
  isRelatedToRange?: string
  showCompare?: boolean,
  showCompareType?: string,
  compareTranscription: SCTATranscriptionUrlId
  base?: string,
  compareTranscriptionDoc?: string,
  manifestationTitle: string,
  manifestation: string,
  surfaceWidth?: number,
  show: boolean,
  handleChangeBase?: (rawText: string) => void,
  showImages?: boolean
  handleChangeInfo?: any

}

// Type alias for URL strings
type SCTATranscriptionUrlId = string;

export const TextCompareItem: React.FC<MyComponentProps> = (props) => {

  const [showCompare, setShowCompare] = useState<boolean>(props.showCompare || true)
  const [show, setShow] = useState<boolean>(props.show)
  const [showImage, setShowImage] = useState<boolean>(false)
  const [rawText, setRawText] = useState<string>("")
  const [isBase, setIsBase] = useState<boolean>(props.isMainText || false)

  useEffect(() => {
    if (props.base === rawText){
      setIsBase(true)
    }
    else{
      setIsBase(false)
    }
  }, [props.base, rawText])

  
  useEffect(() => {
    setShow(props.show)

  }, [props.show])

  const handleTextReceive = (text: string) => {
    setRawText(text)
    // if (props.handleChangeBase){
    //   props.handleChangeBase(text)
    // }
  }

  const displayImage = () => {
    const newManifestations = [{
      manifestation: props.manifestation,
      manifestationTitle: props.manifestationTitle,
      transcription: ""
    }]
    return (
      <div>
        <span onClick={() => { setShowImage(!showImage) }}><FaRegImage /></span>
        {showImage &&
          <div>
            <Surface3Wrapper
              manifestations={newManifestations}
              focusedManifestation={props.manifestation}
              width={props.surfaceWidth}
              hideSelectionList={true}
              isDependentSurface3={true}
              startWord={(props.isMainText && props.targetRange) && parseInt(props.targetRange.split("-")[0])}
              endWord={(props.isMainText && props.targetRange) && parseInt(props.targetRange.split("-")[1])}
            />
          </div>
        }
      </div>
    )

  }
  
  
  return (
    <div className="text-compare-item" style={{ paddingLeft: "5px" }}>
      <style>
        {`
          .text-compare-item:hover {
            filter: brightness(0.9); /* Darken the inherited color */
          }
        `}
      </style>
      <span>
        {/* <a href={"/text?resourceid=" + props.compareTranscription + ((props.relationLabel !== "isQuotedBy" && props.relationLabel !== "isReferencedBy" && props.isRelatedToRange) ? "@" + props.isRelatedToRange : "")}>{props.manifestationTitle}</a> */}
        <span className="lbp-span-link" onClick={() => { props.handleChangeInfo(props.compareTranscription + ((props.relationLabel !== "isQuotedBy" && props.relationLabel !== "isReferencedBy" && props.isRelatedToRange) ? "@" + props.isRelatedToRange : ""))}}>{props.manifestationTitle}</span>
      </span>
      <span> | </span>
      <span className="lbp-span-link" title="show/hide" onClick={() => setShow(!show)}>{show ? <FaEyeSlash /> : <FaEye />}</span>
      <span> | </span>
      <span className="lbp-span-link" title="toggle comparison off" onClick={() => setShowCompare(!showCompare)}>{showCompare ? <FaToggleOn /> : <FaToggleOff/>}</span>
      {!isBase && <span> | </span>}
      {!isBase && <span className="lbp-span-link" title="set as base" onClick={() => props.handleChangeBase?.(rawText)}><FaStar /></span>}
      {props.compareTranscriptionDoc && <span> | </span>}
      {props.compareTranscriptionDoc && <span className="lbp-span-link" title="edit on github" onClick={() => { goToGitHubEdit(props.compareTranscriptionDoc?.split("#")[0] || "", "", props.compareTranscriptionDoc?.split("#")[1] || "") }}><FaEdit /></span>}
      {show && <>
      {
        (props.isMainText && props.targetRange) 
        ?
        <TextView tresourceid={props.compareTranscription} handleChangeInfo={props.handleChangeInfo} hideCitation={true} context={false} start={props.targetRange?.split && parseInt(props?.targetRange?.split("-")[0])} stop={props.targetRange?.split && parseInt(props?.targetRange?.split("-")[1])} compareText={showCompare ? props.base : "" } handleTextReceive={handleTextReceive}/>
        :
        <TextView tresourceid={props.compareTranscription} handleChangeInfo={props.handleChangeInfo} hideCitation={true} compareText={showCompare ? props.base : "" } handleTextReceive={handleTextReceive}/>
        }
        </>
      }
      {displayImage()}
    </div>


  );
};